import React from 'react';
import { type WhiteboardSidePanelItem } from '../../sidepanel-types';
import TimerSidePanelComponent from './timer/SidePanelComponent';
import TimerSidePanelTab from './timer/TabComponent';
import VotingSessionSidePanelTab from './VotingSession/TabComponent';
import VotingSessionPanel from './VotingSession/Panel';

export const facilitationSidePanelItems: WhiteboardSidePanelItem[] = [
  {
    id: 'voting',
    name: 'Voting',
    icon: 'aha-icon aha-icon-voting',
    alwaysRendered: true,
    promoLink: () =>
      !window.currentAccount?.whiteboardsAdvanced
        ? '/suite/whiteboards?upgrade_location=whiteboards_side_panel_voting'
        : undefined,
    hidden({ canFacilitate }) {
      return !canFacilitate;
    },
    tabContent: <VotingSessionSidePanelTab />,
    panel: <VotingSessionPanel />,
  },
  {
    id: 'timer',
    name: 'Timer',
    icon: 'fa-regular fa-timer',
    alwaysRendered: true,
    promoLink: () =>
      !window.currentAccount?.whiteboardsAdvanced
        ? '/suite/whiteboards?upgrade_location=whiteboards_side_panel_timer'
        : undefined,
    hidden({ canFacilitate }) {
      return !canFacilitate;
    },
    tabContent: <TimerSidePanelTab />,
    content: <TimerSidePanelComponent />,
  },
];
